<template>
  <div class="todo-list">
    <div
      class="todo-item"
      v-for="(item, index) in renderList"
      :key="item.id"
    >
    <!-- :src="iconUrl" -->
      <el-image
        class="item-icon"
        :src="iconUrl"
        ></el-image>
      <div class="item-content">
        <div class="title">{{ item.title }}</div>
        <div class="content">{{ item.content }}</div>
        <div class="date">{{ item.date }}</div>
      </div>
      <div>
        <el-button v-if="source !== '1'" @click="clickHandle(index)">去处理</el-button>
        <el-button v-else type="text" @click="detailHandle(index)">查看详情</el-button>
      </div>
    </div>

    <div class="more" v-if="isMore">
      <el-button type="text" @click="loadMore" >加载更多</el-button>
    </div>
  </div>
</template>

<script>
import { useQueryStringify } from '@/utils/useAutoQuery'

export default {
  components: {
  },
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      },
    },
    // -1: 首页, 0: 待处理, 1: 已处理
    source: {
      type: String,
      default: '-1',
    },
    isMore: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      iconUrl: require('@/assets/img/todo-icon.png'),
      toHandleList: { // 去处理跳转参数
        10: { // 年审通知
          path: '/vehicle/vehicleManage/list',
          query: {
            type: 'carMatterTabNo',
            code: 10,
          },
        },
        20: { // 交强险临期
          path: '/vehicle/vehicleManage/list',
          query: {
            type: 'carMatterTabNo',
            code: 20,
          },
        },
        30: { // 商业险临期
          path: '/vehicle/vehicleManage/list',
          query: {
            type: 'carMatterTabNo',
            code: 30,
          },
        },
        40: { // 车证临期
          path: '/vehicle/vehicleManage/list',
          query: {
            type: 'carMatterTabNo',
            code: 40,
          },
        },
        50: { // 有违章
          path: '/vehicle/vehicleManage/list',
          query: {
            type: 'carMatterTabNo',
            code: 50,
          },
        },
        51: { // 违章风险通知
          path: '/vehicle/violation/list',
          query: {
            tabType: '2',
          },
        },
        52: { // 高危违章风险通知
          path: '/vehicle/violation/list',
          query: {
            tabType: '3',
          },
        },
        53: { // 违章风险超时通知
          path: '/vehicle/violation/list',
          query: {
            tabType: '4',
          },
        },
        90: { // 租金逾期
          path: '/underLease/overdue/detailList',
          query: {
            tabType: 'overdue',
          },
        },
        91: { // 司机履约风控提醒
          path: '/underLease/riskControl/driverRiskControl',
          query: {},
        },
        92: { // 未退未续订单-订单列表（个人租赁订单）
          path: '/workbench/rentOrder/list',
          dynamicQuery: {
            attributeId: 'attributeId',
          },
          // attributeId
        },
        93: { // 未退未续订单-订单列表（企业租赁子订单）
          path: '/workbench/entOrder/list',
          query: {
            listType: 'child',
          },
          dynamicQuery: {
            attributeId: 'attributeId',
          },
        },

      },
      toDetailList: { // 查看详情跳转参数
        10: { // 年审通知
          path: '/vehicle/vehicleManage/detail',
          query: {
            hasId: true,
            source: 'detail',
          },
          dynamicQuery: {
            companyId: 'companyId',
          },
        },
        20: { // 交强险临期
          path: '/vehicle/vehicleManage/detail',
          query: {
            hasId: true,
            source: 'detail',
          },
          dynamicQuery: {
            companyId: 'companyId',
          },
        },
        30: { // 商业险临期
          path: '/vehicle/vehicleManage/detail',
          query: {
            hasId: true,
            source: 'detail',
          },
          dynamicQuery: {
            companyId: 'companyId',
          },
        },
        40: { // 车证临期
          path: '/vehicle/vehicleManage/detail',
          query: {
            hasId: true,
            source: 'detail',
          },
          dynamicQuery: {
            companyId: 'companyId',
          },
        },
        50: { // 有违章
          path: '/vehicle/vehicleManage/detail',
          query: {
            hasId: true,
            source: 'detail',
          },
          dynamicQuery: {
            companyId: 'companyId',
          },
        },
        51: { // 违章风险通知
          path: '/vehicle/violation/record',
          query: {},
        },
        52: { // 高危违章风险通知
          path: '/vehicle/violation/record',
          query: {},
        },
        53: { // 违章风险超时通知
          path: '/vehicle/violation/record',
          query: {},
        },
        90: { // 租金逾期
          path: '/underLease/overdue/detailList',
          query: {
            tabType: 'overdue',
          },
        },
        91: { // 司机履约风控提醒
          path: '/underLease/riskControl/riskDetail',
          query: {
            hasId: true,
          },
        },
        92: { // 未退未续订单-个人租赁订单详情
          path: '/workbench/rentOrder/detail',
          query: {
            orderType: 'personal',
            hasId: true,
          },
          dynamicQuery: {
            companyId: 'companyId',
          },
        },
        93: { // 未退未续订单-企业租赁子订单详情
          path: '/workbench/entOrder/detail/child',
          query: {
            hasId: true,
            orderType: 'enterChild',
          },
          dynamicQuery: {
            companyId: 'companyId',
          },
        },
      },
    }
  },
  computed: {
    // 是否从首页引入
    isIndex() {
      return this.source === '-1'
    },
    // 首页、待处理、已处理数据结构和页码显示不统一，重新渲染list
    // 如果需要其他字段，例如id 可通过渲染列表index 找到原始list
    renderList() {
      // 首页和待处理-渲染
      if (this.source !== '1') {
        return this.dataList.map((item) => {
          return {
            title: `系统 ${this.isIndex ? item.name : item.title}`,
            content: `${
              this.isIndex
                ? (`您有 ${item.count}条 ${item.name} 请及时处理`)
                : (`您的 ${item.text} 有 ${item.title} 请及时处理`)
            }`,
            date: this.isIndex ? item.lastTime : item.gmtModified,
          }
        })
      } else {
        // 已处理渲染
        return this.dataList.map((item) => {
          return {
            title: `您的 ${item.text} ${item.title} 已处理完成`,
            content: '',
            date: item.gmtModified,
          }
        })
      }
    },
  },
  created() {

  },
  methods: {
    // 去处理
    clickHandle(index) {
      const item = this.dataList[index]
      this.$emit('closeDialog')

      // 违章待办
      if (this.toHandleList[item.type]) {
        const { path, query, dynamicQuery } = this.toHandleList[item.type]
        // 判断是否有动态参数
        const dynamic = (dynamicQuery && Object.keys(dynamicQuery)) || []
        // 车辆列表单独处理
        if (path === '/vehicle/vehicleManage/list') {
          const queryObj = {
            g: {
              groupType: 'null',
              itemType: query.code,
            },
          }
          this.$router.push(`${path}?${useQueryStringify(queryObj)}`)
        } else {
          const q = {
            ...query,
          }
          if (dynamic && dynamic.length > 0) {
            for (const key in dynamicQuery) {
              q[key] = item[key]
            }
          }
          this.$router.push({
            path,
            query: { ...q },
          })
        }
      }
    },
    // 查看详情
    detailHandle(index) {
      const item = this.dataList[index]
      // 违章待办
      if (this.toDetailList[item.type]) {
        const { path, query, dynamicQuery } = this.toDetailList[item.type]
        // 判断是否有动态参数
        const dynamic = (dynamicQuery && Object.keys(dynamicQuery)) || []
        const q = {
          ...query,
          plateNo: item.text,
        }
        if (dynamic && dynamic.length > 0) {
          for (const key in dynamicQuery) {
            q[key] = item[key]
          }
        }

        // 需要传id的
        if (query.hasId) {
          q.id = item.attributeId
        }
        this.$router.push({
          path,
          query: q,
        })
      }
    },
    // 加载更多
    loadMore() {
      this.$emit('loadMore')
    },
  },
}
</script>

<style lang="scss" scoped>
.todo-list {
  position: relative;
  background: #fff;
  padding: 0 16px;
  line-height: normal;
  .todo-item {
    display: flex;
    padding: 16px 0;
    border-bottom: 1px #DCDEE0 solid;
    .item-icon {
      width: 46px;
      height: 46px;
      ::v-deep img {
        width: 46px;
        height: 46px;
      }
    }
    .item-content {
      display: flex;
      flex-direction: column;
      flex: 1;
      padding: 0 8px;
      .title {
        font-weight: 500;
        color: #323233;
        padding-bottom: 4px;
      }
      .content {
        font-size: 16px;
        padding-bottom: 6px;
      }
      .date {
        color: #979899;
      }
    }
  }
}
.more {
  font-size: 16px;
  display: flex;
  margin-top: 16px;
  justify-content: center;
}
</style>
